module.exports = __webpack_public_path__ + "img/nilesh.5d468bf4.jpg";